import React from 'react'
import PropTypes from 'prop-types'
import translate from '../../../../modules/translate'
import ErrorBoundary from '../../../Error/widgets/ErrorBoundary'
import loadable from '@loadable/component'

const ListNewsFeed = loadable(() => import(/* webpackChunkName: "ListNewsFeed" */ '../../components/ListNewsFeed'))

const errorOptions = {
  component: translate('newsfeed_error'),
  logError: 'ScreenNewsFeed screen display',
}

const ScreenNewsFeed = ({ response: { meta }, match, ...props }) => (
  <ErrorBoundary {...errorOptions} {...props}>
    <ListNewsFeed title={meta.title} />
  </ErrorBoundary>
)

ScreenNewsFeed.propTypes = {
  response: PropTypes.shape({
    meta: PropTypes.object,
  }),
  match: PropTypes.object,
}

export default ScreenNewsFeed
